import type { CentrifugeMessage } from '../messageTypes';

export interface ManagerOnMessage {
  data: {
    type: 'ManagerOn';
    message: { nick: string };
    created_at?: number;
  };
  offset: 80;
}

export interface ManagerOffMessage {
  data: {
    type: 'ManagerOff';
    message: { nick: string; idx: number };
    created_at?: number;
  };
  offset: 80;
}

export const isManagerOnMessage = (item: CentrifugeMessage): item is ManagerOnMessage => {
  return 'data' in item && item.data.type === 'ManagerOn';
};

export const isManagerOffMessage = (item: CentrifugeMessage): item is ManagerOffMessage => {
  return 'data' in item && item.data.type === 'ManagerOff';
};
